import axios from "axios";
import { NOTES_ENDPOINT } from "./GetBatchNotes";

// Upload a PDF/PPT note for a batch. `onProgress` gets 0-100.
const UploadBatchNote = async ({ payload, onProgress }) => {
  const data = new FormData();
  data.append("session", payload.session);
  data.append("course_url", payload.course_url);
  data.append("batch_id", payload.batch_id);
  data.append("title", payload.title);
  data.append("description", payload.description || "");
  data.append("file", payload.file);

  const res = await axios.post(
    NOTES_ENDPOINT + "admin-upload-batch-note.php",
    data,
    {
      headers: { "content-type": "multipart/form-data" },
      timeout: 0,
      onUploadProgress: (e) => {
        if (onProgress && e.total) {
          onProgress(Math.round((e.loaded * 100) / e.total));
        }
      },
    },
  );
  return res ? res.data : null;
};

export default UploadBatchNote;
